import {
  faFacebook,
  faInstagram,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import "../styles/footer.css"; // <- new CSS file

const d = new Date();

function Footer() {
  return (
    <section id="footer">
      <footer className="footer bg-dark p-3 text-light">
        <div className="container">
          <div className="row text-center p-3">
            <div className="col-12 mt-2 copyright fs-6">
              <small>
                &copy; {d.getFullYear()} FRDYPromotions. Minden jog fenntartva.
              </small>
            </div>

            <div className="col-12 mt-2">
              <Link to="/adatvedelem" className="privacy-link">
                Adatvédelmi tájékoztató
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </section>
  );
}

export default Footer;
